import { createContext } from 'react';
import { IOrganizationDetails } from 'interfaces/membership';

export const OrganizationDetailsContext = createContext<
  IOrganizationDetails | undefined
>(undefined);
